import { Button, Input, Spinner, TextField } from "@heroui/react";
import { USER_ROLE_LABELS } from "@storyline/shared";
import PageHeader from "@/src/common/components/page-header";
import { useAdminUsers } from "@/src/users/hooks/use-admin-users";

const formatDate = (value: string): string =>
	new Date(value).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });

const UsersListPage: React.FC = () => {
	const { users, search, setSearch, isLoading, hasError, hasMore, loadMore } = useAdminUsers();

	return (
		<div className="flex flex-col gap-6">
			<PageHeader title="Utilisateurs" description="Comptes des spectateurs inscrits sur Storyline." />

			<TextField value={search} onChange={setSearch} className="max-w-sm">
				<Input placeholder="Rechercher par email ou nom" />
			</TextField>

			{isLoading && users.length === 0 ? (
				<div className="flex justify-center py-16">
					<Spinner size="lg" />
				</div>
			) : hasError ? (
				<p className="rounded-xl border border-border-soft bg-surface p-10 text-center text-sm text-danger">
					Impossible de charger les utilisateurs.
				</p>
			) : users.length === 0 ? (
				<p className="rounded-xl border border-border-soft bg-surface p-10 text-center text-sm text-muted">Aucun utilisateur trouvé.</p>
			) : (
				<>
					<div className="overflow-x-auto rounded-xl border border-border-soft bg-surface">
						<table className="w-full min-w-2xl border-collapse text-sm">
							<thead>
								<tr className="border-border-soft border-b text-left text-xs uppercase tracking-wide text-muted">
									<th className="px-4 py-3 font-medium">Nom</th>
									<th className="px-4 py-3 font-medium">Email</th>
									<th className="px-4 py-3 font-medium">Rôle</th>
									<th className="px-4 py-3 text-right font-medium">Niveau</th>
									<th className="px-4 py-3 font-medium">Inscription</th>
								</tr>
							</thead>
							<tbody>
								{users.map((user) => (
									<tr key={user.id} className="border-border-soft border-b last:border-b-0">
										<td className="px-4 py-3 font-medium text-foreground">{user.displayName}</td>
										<td className="px-4 py-3 text-muted">{user.email}</td>
										<td className="px-4 py-3 text-muted">{USER_ROLE_LABELS[user.role]}</td>
										<td className="px-4 py-3 text-right text-muted">{user.level}</td>
										<td className="px-4 py-3 text-muted">{formatDate(user.createdAt)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					{hasMore ? (
						<div className="flex justify-center">
							<Button variant="secondary" isDisabled={isLoading} onPress={loadMore}>
								{isLoading ? "Chargement…" : "Charger plus"}
							</Button>
						</div>
					) : null}
				</>
			)}
		</div>
	);
};

export default UsersListPage;
